<template>
  <div class='landing'>
    <div class="banner">
      <img src="@/assets/images/logo.svg" alt="">
      <h1>New Ballpark <span>Booking Calendar</span></h1>
      <div class='welcome' v-if="$store.state.repId !== ''">
        <p v-if="booked">Your appointment has been booked!</p>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Landing',
    props: {
      booked: Boolean
    }
  }
</script>

<style lang="scss" scoped>
  .banner {
    max-width: 500px;
    margin: 0 auto;
    text-align: center;
    border-radius: 0 0 10px 10px;
    background-color: rgba(255, 255, 255, 0.92);
    filter: drop-shadow(0 6px 30px rgba(0, 0, 0, 0.25));
    background-blend-mode: multiply;
    background-image: url("~@/assets/images/banner.png");
    padding:24px;
    box-sizing: border-box;
    text-transform: uppercase;

  }

  h1 {
    color: #016040;
    font-family: "proxima-nova", sans-serif;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0.44px;

    span {
      display: block;
      color: #016040;
      font-family: "proxima-nova", sans-serif;
      font-size: 41px;
      font-weight: 800;
      text-transform: uppercase;
    }
  }

  .landing {
    flex-grow: 1;
    position: relative;
    background-image: url("~@/assets/images/welcome.jpg");
    background-size: cover;
    background-position: bottom center;
    box-sizing: border-box;
    text-align: left;
    overflow: hidden;

    >div {
      position: relative;
    }
  }
</style>